import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Input from 'Components/UI/BehavioralFormElement/Text/Currency';
import { withHousehold } from 'Context/HouseholdContext';
import { ContextIndex } from './FieldList';
import { makeHideable } from '../Hideable';

import './index.css';
import withViewContext from './withViewContext';

class Number extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value: numberString },
      },
    } = props;
    const value = numberString ? parseFloat(numberString) : null;

    this.state = {
      value,
      isDone: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => this.setState({ value: parseFloat(res.attributes.value) }))
      .finally(() => this.setState({ isDone: true }));
  }

  componentDidUpdate(prevProps) {
    const { value: prevValue } = prevProps;
    const { triggerBlur, value } = this.props;

    if (triggerBlur && value && value !== prevValue) {
      this.triggerUpdate(value);
    }
  }

  onChange(name, value) {
    this.setState({ value });
  }

  onBlur() {
    const { householdId, uploadValue, answerKey } = this.props;
    const { value } = this.state;
    const index = this.context;
    uploadValue(householdId, answerKey, {
      attributes: {
        value: value.toString(),
        index,
      },
    });
  }

  triggerUpdate(value) {
    this.setState({ value }, () => {
      this.onBlur();
    });
  }

  render() {
    const {
      onBlur,
      onChange,
      props: {
        decimalScale, name, placeholder, min,
      },
      state: { value, isDone },
    } = this;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <Input
          decimalScale={decimalScale}
          test={name}
          name={name}
          label={placeholder}
          placeholder={placeholder}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          min={min}
        />
      </div>
    );
  }
}

Number.propTypes = {
  decimalScale: PropTypes.number,
  name: PropTypes.string.isRequired,
  uploadValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  answerKey: PropTypes.string.isRequired,
  householdId: PropTypes.number.isRequired,
  apiResponse: PropTypes.instanceOf(Object),
  min: PropTypes.number,
  triggerBlur: PropTypes.bool,
  value: PropTypes.number,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};

Number.defaultProps = {
  decimalScale: 0,
  apiResponse: { attributes: {} },
  min: null,
  triggerBlur: false,
  value: null,
};

Number.contextType = ContextIndex;

const NumberInput = withHousehold(withQuestionnaireFuncs(withViewContext(Number)));

export default makeHideable(NumberInput);
